module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./DetailedListView.js"));
	}, "DetailedListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DetailedListView!./src/pages/Promote/Schedule/DetailedList/DetailedListView.js
// module id = 1140
// module chunks = 438